var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"EveIntro"},[_c('h3',[_vm._v(_vm._s(_vm.event))]),_c('img',{attrs:{"src":_vm.img_src}}),_c('p',{staticStyle:{"white-space":"pre-wrap"},domProps:{"innerHTML":_vm._s(_vm.intro)}})])}
var staticRenderFns = []

export { render, staticRenderFns }